import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { AdminUserListRequest } from '../../requests/platform/admin-user-list.request';
import { AdminUserDetailsResponse, AdminUserExportResponse, AdminUserIndicatorsResponse, AdminUserListResponse } from '../../responses/platform/admin-user-list.response';

@Injectable({ providedIn: 'root' })
export class AdminUserListService extends CommonService {
  constructor(private http: HttpClient) { super(); }

  public list(request: AdminUserListRequest): Observable<AdminUserListResponse> {
    return this.http
      .post<AdminUserListResponse>(`${environment.urlApiPlatform}AdminUserList/List`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public export(request: AdminUserListRequest): Observable<AdminUserExportResponse> {
    return this.http
      .post<AdminUserExportResponse>(`${environment.urlApiPlatform}AdminUserList/Export`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public indicators(): Observable<AdminUserIndicatorsResponse> {
    return this.http
      .get<AdminUserIndicatorsResponse>(`${environment.urlApiPlatform}AdminUserList/Indicators`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public details(idUser: number): Observable<AdminUserDetailsResponse> {
    return this.http
      .get<AdminUserDetailsResponse>(`${environment.urlApiPlatform}AdminUserList/Details/${idUser}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
